import React, {memo} from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const strategyBuilderSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 10V21.5M10.5 38V31M10.5 31H21L27.2429 21.5M10.5 31V21.5M32.5 13.5L27.2429 21.5M10.5 21.5H27.2429M27.2429 21.5H38" stroke="currentColor"/>
    </svg>


)

const StrategyBuilder: React.FC<SvgIconProps> = memo((props) => <SvgIcon {...props}>{strategyBuilderSvg}</SvgIcon>)

export default StrategyBuilder
